import React from "react";
import UserAnalysisContent from "./user-analysis-content.jsx";
import PlateAnalysisContent from "./plate-analysis-content.jsx";
import CompleteAnalysisContent from "./complete-analysis-content.jsx";

const ReportContent = ({ data, analysis, brandModels, tableColumns }) => {
    if (!data) return null;

    return (
        <>
            { analysis === 'user' && (
                <UserAnalysisContent payload={data} tableColumns={tableColumns}/>
            )}

            { analysis === 'plate' && (
                <PlateAnalysisContent payload={data}/>
            )}

            { analysis === 'complete' && (
                <CompleteAnalysisContent payload={data} brandModels={brandModels}/>
            )}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;